<script>
export default {
  data() {
    return {
      loanIdentifier: '',
      firstName: '',
      middleName: '',
      lastName: '',
      dob: '',
    }
  },
  computed: {
    placeholders() {
      return process.env.NODE_ENV === 'production'
        ? {}
        : {
            loanIdentifier: 'Type Loan Identifier',
            firstName: 'Type First Name',
            middleName: 'Type Middle Name',
            lastName: 'Type Last Name',
            dob: 'DD/MM/YYYY',
            phoneNumber: '(xxx)xxx-xxxx',
            address: 'Type Address here',
            ssn: 'xxx-xxx-xxxx',
            streetAddress: 'Type Street Address',
            zip: 'Type ZIP',
            taxID: 'Type Tax ID',
          }
    },
  },
}
</script>

<template>
  <div>
    <b-row>
      <b-col md="3"
        ><BaseEInputText
          id="loanIdentifier"
          v-model="loanIdentifier"
          v-validate="'required'"
          type="text"
          name="loanIdentifier"
          label-content="Loan Identifier"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('loanIdentifier'),
          }"
          :placeholder="placeholders.loanIdentifier"
        ></BaseEInputText>
        <div v-show="errors.has('loanIdentifier')" class="error">
          Loan Identifier is required
        </div></b-col
      >
    </b-row>
    <b-row>
      <b-col md="3"
        ><BaseEInputText
          id="firstName"
          v-model="firstName"
          v-validate="'required'"
          type="text"
          name="firstName"
          label-content="First Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('firstName'),
          }"
          :placeholder="placeholders.firstName"
        ></BaseEInputText>
        <div v-show="errors.has('firstName')" class="error">
          First Name is required
        </div></b-col
      >
      <b-col md="3">
        <BaseEInputText
          id="middleName"
          v-model="middleName"
          v-validate="'required'"
          type="text"
          name="middleName"
          label-content="Middle Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('middleName'),
          }"
          :placeholder="placeholders.middleName"
        ></BaseEInputText>
        <div v-show="errors.has('middleName')" class="error">
          Middle Name is required
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="lastName"
          v-model="lastName"
          v-validate="'required'"
          type="text"
          name="lastName"
          label-content="Last Name"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('lastName'),
          }"
          :placeholder="placeholders.lastName"
        ></BaseEInputText>
        <div v-show="errors.has('lastName')" class="error">
          Last Name is required
        </div>
      </b-col>
      <b-col md="3">
        <BaseEInputText
          id="dob"
          v-model="dob"
          v-validate="'required|date'"
          type="text"
          name="dob"
          label-content="DOB"
          mark-required
          :class="{
            input: true,
            'is-danger': errors.has('dob'),
          }"
          :placeholder="placeholders.dob"
        ></BaseEInputText>
        <div v-show="errors.has('dob')" class="error">
          DOB is required
        </div>
      </b-col>
    </b-row>
    <b-row> </b-row>
  </div>
</template>

<style lang="scss" module>
@import '@design';
</style>
